module.exports = __webpack_public_path__ + "static/media/burger.2c944e58.png";